<template>
<div>
    
</div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
    components:{

    },
	data() {
		return {

		}
	},
	watch:{

	},
	created() {

	},
	methods: {
		
	},
	mounted() {

	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
}
</style>
